import cn from 'classnames';
import {useLocation} from 'react-router-dom';
interface ICustomBagde {
  title?: string;
  onRemoveItem?: () => void;
  disable?: boolean;
  hasRemoveItem?: boolean;
  textColor?: string;
}

const CustomBadge = ({
  title,
  onRemoveItem,
  disable = false,
  hasRemoveItem = true,
  textColor = 'text-farm-shop-500',
}: ICustomBagde) => {
  const locational = useLocation();

  return (
    <div
      className={cn('flex justify-between w-fit p-2 gap-2 rounded-full', {
        'bg-gray-50': disable,
        'bg-farm-shop-200': !disable,
      })}
    >
      <span
        className={cn('text-sm ', {
          'bg-gray-50': disable,
          [textColor]: !disable,
        })}
      >
        {title}
      </span>
      {hasRemoveItem && locational?.state?.status !== 'expired' && (
        <i
          className={cn('icon-nameClose-remove ', {
            'bg-gray-50': disable,
            [textColor]: !disable,
          })}
          onClick={!disable ? onRemoveItem : undefined}
        />
      )}
    </div>
  );
};

export default CustomBadge;
